ReactContentQuery.ExternalScripts.loadForo = {
    onPostRender: function (wpContext, handlebarsContext) {
        SystemJS.import("/SiteAssets/js/core-client-common-library.min.js").then((cl) => {
            $('.grid-links__link .card__title').matchHeight();
            $('.grid-links__item').matchHeight(); 
        });
    }
}        